import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import type { TransactionTrackingDeliveryCode } from "features/shipmentTracking/types";
import { useShipmentTrackingContext } from "./ShipmentTrackingProvider";

const useRowActions = () => {
    const { openView } = useShipmentTrackingContext();

    return ({ row }: GridRowParams<TransactionTrackingDeliveryCode>) => [
        <GridActionsCellItem
            key='view'
            onClick={() => openView(row)}
            icon={<VisibilityIcon />}
            label='View'
            data-test-id={`shipmentTracking.table.row.${row.coreId}.actions.view`}
        />
    ];
};

export default useRowActions;
